<ng-container>
    @if(isPageRestrictionLoaded){
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility">Service Codes</h1>
            <!-- <div class="action">
                <ppl-button label="Add Service Code" icon="fa fa-plus" [customClass]="'primary-button'"
                    [iconPosition]="'left'" (click)="onAddServiceCode()"></ppl-button>
            </div> -->
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="table-style">
                    <ppl-list-table [pageConfig]="programName" [sharedDataKey]="sharedDataKey" (rowDetailEvent)="rowClicked($event)" [loadPage]="lazyLoad"
                        [columnsToBeHidden]="columnsToBeHidden" [actionsToBeHidden]="actionsToBeHidden"
                        [jsonList]="'list_service_codes'" [from]="'claims'"
                        rowDataAccessibilityKey="code"
                        >
                    </ppl-list-table>
                </div>
            </div>
        </div>
    </div>
    }

</ng-container>